import React, { useContext } from 'react';
import { Column } from '../components/shared/Column';
import { Grid } from '../components/shared/Grid';

import { BaseLayout } from '../components/template/BaseLayout';
import { MLIStepper } from '../components/features/MLIStepper';
import { MLICalucation } from '../components/features/MLICalculation';
import { Loader } from '../components/shared/Loader';
import { FormContext } from '../store/MLI/MLIContext';

export const Home = () => {
    const { isLoading } = useContext(FormContext);
    return (
        <BaseLayout>
            <Grid>
                <Column cols={[12, null, null, 6]}>
                    <MLIStepper />
                </Column>

                <Column cols={[12, null, null, 5]} pre={[null, null, null, 1]}>
                    <MLICalucation />
                </Column>
            </Grid>

            <Loader isLoading={isLoading} />
        </BaseLayout>
    );
};
